import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import s from './CardHeading.scss';
const CardHeading = ({ children, className })=>{
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement(Heading, {
        className: c(s['root'], className)
    }, /*#__PURE__*/ React.createElement("span", {
        className: s['prefix']
    }, t('sidebar.exclusives.heading.prefix')), /*#__PURE__*/ React.createElement("span", {
        className: s['exclusive-type']
    }, children));
};
CardHeading.displayName = 'CardHeading';
export default CardHeading;
